import React from 'react';
import { Form, Input, Row, Col, InputNumber, message } from 'antd';
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { postFrom, config } from '../../../../axios';
import moment from 'moment'

class Delete extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            id: null,

        }
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    loadPackage = (id) => {

        this.setState({ loading: true, id });
        let data = { billId: id };
        postFrom({
            url: config.API_bill_getBillById,
            data,
        }).then(res => {

            this.setState({ data: res, loading: false });
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })
    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {
            if (!error) {
                postFrom({
                    url: config.API_bill_deletedBill,
                    data: { billId: this.state.id }
                }).then(res => {
                    this.setState({ loading: false, data: {} });
                    this.props.handleCancel();
                    message.success(`删除成功`);
                    this.props.handleSearch();
                }).catch(err => {
                    message.error(err.message || '接口异常');
                    this.setState({ loading: false })
                })
            }
        })
    }

    render() {
        let { visible, handleCancel, form: { getFieldDecorator } } = this.props;
        let {
            loading,
            data

        } = this.state;

        return <ModalDom
            title="删除"
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            onCancel={handleCancel}
        >
            <div className="custom">
                <Form labelCol={{ span: 0 }}
                    wrapperCol={{ span: 24 }}>
                    <Row>
                        <Col>
                            <DetailTitle title="房源" boxStyle={{ marginTop: 0 }} />
                            <CustomRow>
                                <CustomCol label="楼栋/楼盘" required={false} >
                                    {getFieldDecorator('buildingName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.buildingName
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="房间号" required={false} >
                                    {getFieldDecorator('roomNo', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.roomNo
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <DetailTitle title="租客" />
                            <CustomRow>
                                <CustomCol label="姓名" required={false} >
                                    {getFieldDecorator('customerName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.customerName
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="证件号码" required={false} >
                                    {getFieldDecorator('credentialNumber', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.credentialNumber
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="手机号码" required={false} >
                                    {getFieldDecorator('customerPhone', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.customerPhone
                                    })(
                                        <Input
                                            placeholder={'请输入'} disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                        <Col>
                            <DetailTitle title="账单" />
                            <CustomRow>
                                <CustomCol label="账单名称" required={false} >
                                    {getFieldDecorator('feeName', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.feeName
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="应收日期" required={false} >
                                    {getFieldDecorator('mustPayDate', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.mustPayDate ? moment(data.mustPayDate).format('YYYY-MM-DD') : null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="应收金额" className="disabledRed" required={false} subfix={<div style={{ background: "#f0f2f5" }}>元</div>} >
                                    {getFieldDecorator('billMoney', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.billMoney

                                    })(
                                        <InputNumber
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}

                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                            <CustomRow divider>
                                <CustomCol label="账单周期" required={false} >
                                    {getFieldDecorator('faceDetecteds', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.billBeginDate && data.billEndDate ? moment(data.billBeginDate).format('YYYY-MM-DD') + " 至 " + moment(data.billEndDate).format('YYYY-MM-DD') : null
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                                <CustomCol label="账单说明" colStyle={{ width: "501px" }} required={false} >
                                    {getFieldDecorator('feeRemark', {
                                        rules: [{
                                            required: false, message: '请输入',
                                        }],
                                        initialValue: data.feeRemark
                                    })(
                                        <Input
                                            placeholder={'请输入'}
                                            disabled={true}
                                            autoComplete={'off'}
                                        />
                                    )}
                                </CustomCol>
                            </CustomRow>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalDom>
    }


}

export default Form.create()(Delete);


// WEBPACK FOOTER //
// ./src/page/Bill/components/Receiv/delete.js